import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, Timeline } from 'antd';
import apiFactory from "../../../api";
import { formatTime } from "../../../utils/formatTime";
import { COMMENT_HISTORY } from "../../../config/Constant";
import {useInfoUser} from "../../../store/UserStore";

const CommentHistoryModal = ({ taskActivityCode, isModalCommentHistory, setIsModalCommentHistory }) => {
  const lastObserver = useRef();

  const [isLoading, setIsLoading] = useState(false);
  const [commentHistories, setCommentHistories] = useState([]);
  const [lastEditCommentTime, setLastEditCommentTime] = useState(null);
  const [isMoreDataCommentHistory, setIsMoreDataCommentHistory] = useState(false);
  const { languageMap } = useInfoUser();

  const lastCommentHistoryRef = (node) => {
    if (isLoading || !isMoreDataCommentHistory) return;
    if (lastObserver.current) lastObserver.current.disconnect();

    lastObserver.current = new IntersectionObserver(async (entries) => {
      if (entries[0].isIntersecting) {
        setIsLoading(true);
        await fetchDataCommentHistory();
      }
    });

    if (node) lastObserver.current.observe(node);
  };

  const fetchDataCommentHistory = async () => {
    try {
      setIsLoading(true);

      const request = {
        taskActivityCode: taskActivityCode,
        lastTaskActivityTime: lastEditCommentTime,
        limit: 10
      }
      const response = await apiFactory.taskActivityApi.getCommentListHistory(request);

      if (response?.status !== 200) return ;

      setCommentHistories([...commentHistories, ...response?.data]);
      setLastEditCommentTime(response?.data[response?.data?.length - 1]?.createdAt);
      setIsLoading(false);

      if (response?.data?.length < COMMENT_HISTORY.LIMIT) {
        setIsMoreDataCommentHistory(false);
      } else {
        setIsMoreDataCommentHistory(true);
      }
    } catch (e) {
      console.error("get comment list history fail:", e);
    }
  }

  const onClose = () => {
    setIsModalCommentHistory(false);
  }

  useEffect(() => {
    fetchDataCommentHistory();
  }, []);

  return (
    <Modal
      title={languageMap?.["modal.sideBarTimeLine.commentHistory.title"] ?? "COMMENT HISTORY"}
      open={isModalCommentHistory}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          {languageMap?.["modal.sideBarTimeLine.commentHistory.close"] ?? "Close"}
        </Button>,
      ]}
      width={600}
    >
      <Timeline className="h-[60vh] overflow-y-scroll p-2">
        {commentHistories?.map((comment, index) => (
          <Timeline.Item key={comment?.taskActivityLogCode}>
            <div
              ref={index === commentHistories?.length - 1 ? lastCommentHistoryRef : null}
            >
              <div className="flex gap-[10px] my-1">
                <span className="font-medium">{languageMap?.["modal.sideBarTimeLine.commentHistory.editTime"] ?? "Edit time: "} </span>
                <span>{formatTime(comment?.createdAt)}</span>
              </div>
              <div className="flex">
                <span className="font-medium min-w-[15%]">{languageMap?.["modal.sideBarTimeLine.commentHistory.content"] ?? "Content: "} </span>
                <span dangerouslySetInnerHTML={{ __html: comment?.content }} />
              </div>
            </div>
          </Timeline.Item>
        ))}
      </Timeline>
    </Modal>
  );
};

export default CommentHistoryModal;
